import React from "react";
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router-dom";

import ShippingPricingStore from "../store";

const ShippingPricingEdit = () => {
  const { id } = useParams();

  const mode = "edit";

  return (
    <div>
      <ShippingPricingStore mode={mode} id={id} />
    </div>
  );
};

export default ShippingPricingEdit;
